const keymaps = ["sublime", "vim", "emacs"];

export default keymaps;
